import { __awaiter } from '../../../../../../_virtual/_tslib.js';
import { jsx } from 'react/jsx-runtime';
import { isEmailOTPWalletConnector, isEmailWalletConnector } from '@dynamic-labs/multi-wallet';
import { useInternalDynamicContext } from '../../../../context/DynamicContext/useInternalDynamicContext.js';
import { WidgetPortal } from '../../components/WidgetPortal/WidgetPortal.js';
import '../../../../context/ViewContext/ViewContext.js';
import '../../../../context/ErrorContext/ErrorContext.js';
import '@dynamic-labs/sdk-api';
import { logger } from '../../../../shared/logger.js';
import '@dynamic-labs/iconic';
import 'react';
import '../../../../utils/constants/colors.js';
import '../../../../shared/consts/index.js';
import '../../../../config/ApiEndpoint.js';
import '../../../../context/CaptchaContext/CaptchaContext.js';
import { useConnectAndSignSplitSteps } from '../../../../utils/hooks/authenticationHooks/useConnectAndSignSplitSteps/useConnectAndSignSplitSteps.js';
import { DefaultPendingSignModalContent } from '../../components/DefaultPendingSignModalContent/DefaultPendingSignModalContent.js';
import { EmailConnectorPendingSignModalContent } from '../../components/EmailConnectorPendingSignModalContent/EmailConnectorPendingSignModalContent.js';
import { EmailOTPConnectorPendingSignModalContent } from '../../components/EmailOTPConnectorPendingSignModalContent/EmailOTPConnectorPendingSignModalContent.js';

const PendingSignModal = () => {
    const { selectedWalletConnector, setSelectedWalletConnector, setMultiWalletWidgetState, } = useInternalDynamicContext();
    const { signAlreadyConnectedUser } = useConnectAndSignSplitSteps();
    const handleClick = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            if (selectedWalletConnector) {
                yield signAlreadyConnectedUser({
                    walletConnector: selectedWalletConnector,
                });
            }
        }
        catch (e) {
            logger.error(e);
        }
        finally {
            setMultiWalletWidgetState('idle');
        }
    });
    const handleOnClickBackdrop = () => {
        setMultiWalletWidgetState('idle');
        setSelectedWalletConnector(null);
    };
    if (selectedWalletConnector !== null) {
        if (isEmailOTPWalletConnector(selectedWalletConnector)) {
            return (jsx(WidgetPortal, Object.assign({ onBackdropClick: handleOnClickBackdrop, disablePadding: true }, { children: jsx(EmailOTPConnectorPendingSignModalContent, { walletConnector: selectedWalletConnector }) })));
        }
        if (isEmailWalletConnector(selectedWalletConnector)) {
            return (jsx(WidgetPortal, Object.assign({ onBackdropClick: handleOnClickBackdrop }, { children: jsx(EmailConnectorPendingSignModalContent, { emailWalletConnector: selectedWalletConnector }) })));
        }
    }
    return (jsx(WidgetPortal, Object.assign({ onBackdropClick: handleOnClickBackdrop }, { children: jsx(DefaultPendingSignModalContent, { walletConnector: selectedWalletConnector, onClickToSign: handleClick }) })));
};

export { PendingSignModal };
